<template>
  <div class="order-item_good-item">
    <img :src="img" alt="商品图片" class="order-item_good-item_img" />
    <div style="margin-left: 10px;">
      <p>【{{ sn }}】</p>
      <p>{{ name }}</p>
      <p>￥{{ price }} x {{ num }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      img: String,
      sn: String,
      name: String,
      price: String,
      num: [String, Number]
    }
  }
</script>

<style>
  .order-item_good-item {
    display: flex;
    align-items: center;
    padding: 5px;
  }

  .order-item_good-item_img {
    width: 50px;
    height: 50px;
    object-fit: scale-down;
    border-radius: 4px;
  }
</style>